import React, { useEffect } from 'react'
import './orders.css' 
import { collection, addDoc } from "firebase/firestore";
import { selectAccount } from './features/user/UserSlice'
import { useSelector } from 'react-redux'
import {db} from './firebase'

import { useStateValue } from './StateProvider'
import CheckoutProduct from './components/CheckoutProduct'

function Orders() {

    const user = useSelector(selectAccount)
     const [{ basket }, dispatch] = useStateValue()


    useEffect(() => {
        const storeOrder = async () => {
            try {
            const docRef = await addDoc(collection(db, "orders"), {
                items:  basket.map(item => (
                                <CheckoutProduct
                                    image = {item.img}
                                    title ={item.title}
                                    id = {item.id}
                                    price = {item.price}
                                    rating = {item.rating}

                                />
                            ))
            });
            console.log("Document written with ID: ", docRef.id);
            } catch (e) {
            console.error("Error adding document: ", e);
            }
        }

        if (user){
             storeOrder()
        }
         
    }, [user])

    return (
        <div className='orders'>
            <h1>ORDERSW</h1>
        </div>
    )
}

export default Orders
